import Kpi from "@/models/Kpi";
export default class {
  id = null;
  parentId = null;
  name = null;
  value = null;
  units = null;
  dataType = "string";
  minValue = null;
  maxValue = null;
  order = 0;
  maxChildrenCount = 0;
  childrenCount = 0;
  children = [];
  childFields = [];
  style = null;
  type = "SIMPLE";

  constructor (data = {}) {
    for (let key in this) {
      if (data[key] !== undefined) {
        if (data[key] !== null && data[key] !== 'null') {
          this[key] = data[key];
        } else {
          this[key] = null;
        }
      }
    }
    if (this.dataType === 'date') {
      this.value = Number(this.value) || null;
    }
    if (this.dataType === 'boolean') {
      this.value = this.value === 'true';
    }
    if (['double'].includes(this.dataType)) {
      this.dataType = 'string'
    }
    if (this.children.length){
      this.children = this.children.map(c => new Kpi(c))
    }
  }
  getClass () {
    if (this.style == 'none') {
      if (['int', 'double', 'date'].indexOf(this.dataType) != -1) {
        let min, max, vl;
        if (this.value && (vl = Number(this.value.toString().replace(',', '.')))) {
          if ((this.minValue.length > 0) && (this.maxValue.length > 0)) {
            // указаны обе границы
            if ((min = Number(this.minValue.replace(',', '.'))) && (max = Number(this.maxValue.replace(',', '.')))) {
              if (vl < min) {
                return 'is-invalid';
              } else if (vl > max) {
                return 'is-invalid';
              } else {
                return 'none';
              }
            }
          } else if (this.minValue.length > 0) {
            // указана только нижняя граница
            if ((min = Number(this.minValue.replace(',', '.')))) {
              if (vl < min) {
                return 'is-invalid';
              } else {
                return 'none';
              }
            }
          } else if (this.maxValue.length > 0) {
            // указана только верхняя граница
            if ((max = Number(this.maxValue.replace(',', '.')))) {
              if (vl > max) {
                return 'is-invalid';
              } else {
                return 'none';
              }
            }
          }
        }
      }
    }

    return this.style;
  }
  getDataToSave () {
    let data = {};
    for (let key in this) {
      if (this[key] === undefined || this[key] === null) {
        if (['parentId', 'id'].indexOf(key) != -1) {
          // data[key] = null;
        } else {
          data[key] = 'null';
        }
      } else if (this[key] === '') {
        data[key] = 'null';
      } else {
        data[key] = this[key];
      }
    }
    return data;
  }
  createEvent () {
    const kpi = {
      name: null,
      parentId: this.id,
      maxChildrenCount: this.childFields.length,
      order: 0,
      children: [...this.childFields]
    }
    return new Kpi(kpi)
  }
}
